import React, { useMemo } from "react";
import { Stage, Step } from "../../../api/model/scenario";
import { steps } from "../../../pages/QuotationForm/steps";
import { StepContext } from "../../../contexts/StepContext";
import './index.scss';
import { Quotation } from "../../../model/quotation";

interface Props {
    step: Step,
    nextStepHandler: (quotation: Quotation) => void;
    backStepHandler: (quotation: Quotation, stepCallback?: (stage: Stage) => void) => void;
}

export const StepComponent = ({ step, nextStepHandler, backStepHandler }: Props) => {
    const contextValue = useMemo(() => ({
        backStepListener: backStepHandler,
        nextStepListener: nextStepHandler,
    }), [backStepHandler, nextStepHandler]);

    return (
        <StepContext.Provider value={contextValue}>
            <div className="step-component">
                {React.createElement(steps[step.code], {
                    key: step.code,
                    step
                })}
            </div>
        </StepContext.Provider>
    );
};